import {colors} from '../variables';

export const align = {
  name: 'align',
  label: 'Alignment',
  component: 'radio-group',
  variant: 'button',
  options: ['left', 'center', 'right'],
};

export const textColor = {

  name: 'textColor',
  label: 'Text Color',
  component: 'color',
  widget: 'block',
  colors

};
const textFields = [
  textColor,
  {
    name: 'fontSize',
    label: 'Font Size',
    component: 'number',
    step: 1,
  },
  {
    name: 'lineHeight',
    label: 'Line height',
    component: 'number',
    step: 1,
  },
  {
    name: 'bold',
    label: 'Bold',
    component: 'select',
    options: ['normal', 'lighter', 'medium', 'bold'],
  },
  align
];

export const textContent = {
  name: 'text',
  label: 'Text Settings',
  component: 'group',
  fields: [
    {
      name: '',
      label: '',
      component: 'responsive-group',
      fields: textFields
    }
  ]
};

export const text = {
  name: 'text',
  label: '',
  component: 'responsive-group',
  fields: textFields
};
